import { ref, computed, watch } from 'vue'

// Restore from sessionStorage if available (survives page reload)
const stored = sessionStorage.getItem('viewAsUser')
const viewAsUser = ref(stored ? JSON.parse(stored) : null)

// Sync to sessionStorage on every change
watch(viewAsUser, (val) => {
  if (val) {
    sessionStorage.setItem('viewAsUser', JSON.stringify(val))
  } else {
    sessionStorage.removeItem('viewAsUser')
  }
}, { deep: true })

export function useViewAs() {
  const isViewingAsOther = computed(() => viewAsUser.value !== null)

  const viewAsDisplayName = computed(() => {
    if (!viewAsUser.value) return null
    return `${viewAsUser.value.givenName} ${viewAsUser.value.surname}`
  })

  function setViewAsUser(user) {
    viewAsUser.value = user
  }

  function clearViewAs() {
    viewAsUser.value = null
  }

  // Returns the viewAs query param value, or null
  function getViewAsParam() {
    return viewAsUser.value?.userId || null
  }

  return {
    viewAsUser,
    isViewingAsOther,
    viewAsDisplayName,
    setViewAsUser,
    clearViewAs,
    getViewAsParam
  }
}
